import { useState } from "react";
import atpAutoteile from "@/assets/logos/atp-autoteile.jpg?w=288;432;576&format=webp&quality=82&as=srcset";
import atpAutoteileFallback from "@/assets/logos/atp-autoteile.jpg?w=432&format=webp&quality=82";
import bluecode from "@/assets/logos/bluecode.jpg?w=288;432;576&format=webp&quality=82&as=srcset";
import bluecodeFallback from "@/assets/logos/bluecode.jpg?w=432&format=webp&quality=82";
import casimum from "@/assets/logos/casimum.jpg?w=288;432;576&format=webp&quality=82&as=srcset";
import casimumFallback from "@/assets/logos/casimum.jpg?w=432&format=webp&quality=82";
import diaeko from "@/assets/logos/diaeko.jpg?w=288;432;576&format=webp&quality=82&as=srcset";
import diaekoFallback from "@/assets/logos/diaeko.jpg?w=432&format=webp&quality=82";
import eyeAble from "@/assets/logos/eye-able.jpg?w=288;432;576&format=webp&quality=82&as=srcset";
import eyeAbleFallback from "@/assets/logos/eye-able.jpg?w=432&format=webp&quality=82";
import frostfutter from "@/assets/logos/frostfutter.jpg?w=288;432;576&format=webp&quality=82&as=srcset";
import frostfutterFallback from "@/assets/logos/frostfutter.jpg?w=432&format=webp&quality=82";
import happyCheeze from "@/assets/logos/happy-cheeze.jpg?w=288;432;576&format=webp&quality=82&as=srcset";
import happyCheezeFallback from "@/assets/logos/happy-cheeze.jpg?w=432&format=webp&quality=82";
import igo from "@/assets/logos/igo.jpg?w=288;432;576&format=webp&quality=82&as=srcset";
import igoFallback from "@/assets/logos/igo.jpg?w=432&format=webp&quality=82";
import liebesgut from "@/assets/logos/liebesgut.jpg?w=288;432;576&format=webp&quality=82&as=srcset";
import liebesgutFallback from "@/assets/logos/liebesgut.jpg?w=432&format=webp&quality=82";
import mondi from "@/assets/logos/mondi.jpg?w=288;432;576&format=webp&quality=82&as=srcset";
import mondiFallback from "@/assets/logos/mondi.jpg?w=432&format=webp&quality=82";
import muecke from "@/assets/logos/muecke.jpg?w=288;432;576&format=webp&quality=82&as=srcset";
import mueckeFallback from "@/assets/logos/muecke.jpg?w=432&format=webp&quality=82";
import procani from "@/assets/logos/procani.jpg?w=288;432;576&format=webp&quality=82&as=srcset";
import procaniFallback from "@/assets/logos/procani.jpg?w=432&format=webp&quality=82";
import schlafstil from "@/assets/logos/schlafstil.jpg?w=288;432;576&format=webp&quality=82&as=srcset";
import schlafstilFallback from "@/assets/logos/schlafstil.jpg?w=432&format=webp&quality=82";
import spessarttraum from "@/assets/logos/spessarttraum.jpg?w=288;432;576&format=webp&quality=82&as=srcset";
import spessarttraumFallback from "@/assets/logos/spessarttraum.jpg?w=432&format=webp&quality=82";
import vantastic from "@/assets/logos/vantastic.jpg?w=288;432;576&format=webp&quality=82&as=srcset";
import vantasticFallback from "@/assets/logos/vantastic.jpg?w=432&format=webp&quality=82";
import velivery from "@/assets/logos/velivery.jpg?w=288;432;576&format=webp&quality=82&as=srcset";
import veliveryFallback from "@/assets/logos/velivery.jpg?w=432&format=webp&quality=82";
import vrImmoservice from "@/assets/logos/vr-immoservice.jpg?w=288;432;576&format=webp&quality=82&as=srcset";
import vrImmoserviceFallback from "@/assets/logos/vr-immoservice.jpg?w=432&format=webp&quality=82";
import petando from "@/assets/logos/petando.png?w=288;432;576&format=webp&quality=82&as=srcset";
import petandoFallback from "@/assets/logos/petando.png?w=432&format=webp&quality=82";

type Logo = { srcSet: string; src: string; name: string; href?: string; alt?: string };

const LOGOS: Logo[] = [
  { srcSet: atpAutoteile, src: atpAutoteileFallback, name: "ATP Autoteile" },
  { srcSet: bluecode, src: bluecodeFallback, name: "Bluecode" },
  { srcSet: casimum, src: casimumFallback, name: "Casimum" },
  { srcSet: diaeko, src: diaekoFallback, name: "Diaeko" },
  { srcSet: eyeAble, src: eyeAbleFallback, name: "Eye-Able" },
  { srcSet: frostfutter, src: frostfutterFallback, name: "Frostfutter Perleberg" },
  { srcSet: happyCheeze, src: happyCheezeFallback, name: "Happy Cheeze" },
  { srcSet: igo, src: igoFallback, name: "iGO" },
  { srcSet: liebesgut, src: liebesgutFallback, name: "Liebesgut" },
  { srcSet: mondi, src: mondiFallback, name: "Mondi" },
  { srcSet: muecke, src: mueckeFallback, name: "Mücke" },
  { srcSet: petando, src: petandoFallback, name: "petando.de", href: "https://petando.de", alt: "petando.de" },
  { srcSet: procani, src: procaniFallback, name: "Procani" },
  { srcSet: schlafstil, src: schlafstilFallback, name: "Schlafstil" },
  { srcSet: spessarttraum, src: spessarttraumFallback, name: "Spessarttraum" },
  { srcSet: vantastic, src: vantasticFallback, name: "Vantastic Foods" },
  { srcSet: velivery, src: veliveryFallback, name: "Velivery" },
  { srcSet: vrImmoservice, src: vrImmoserviceFallback, name: "VR Immoservice" },
];

type Texts = {
  ariaLabel: string;
  pauseLabel: string;
  resumeLabel: string;
  altPattern: (name: string) => string;
};

const DE_TEXTS: Texts = {
  ariaLabel: "Referenzen und Kundenlogos",
  pauseLabel: "Animation pausieren",
  resumeLabel: "Animation fortsetzen",
  altPattern: (n) => `Logo von ${n}`,
};

const EN_TEXTS: Texts = {
  ariaLabel: "References and client logos",
  pauseLabel: "Pause animation",
  resumeLabel: "Resume animation",
  altPattern: (n) => `Logo of ${n}`,
};

export function LogoSlider({ locale = "de" }: { locale?: "de" | "en" }) {
  const t = locale === "en" ? EN_TEXTS : DE_TEXTS;
  const [paused, setPaused] = useState(false);
  const logos = LOGOS;

  return (
    <div className="logo-slider-root" aria-label={t.ariaLabel} data-logo-slider="marquee">
      <div className="logo-slider-mask" data-logo-slider-mask>
        <div
          className={`logo-slider-track${paused ? " is-paused" : ""}`}
          data-logo-slider-track
          style={{ animationPlayState: paused ? "paused" : "running" }}
        >
          {[0, 1].map((setIndex) => (
            <div
              key={setIndex}
              className="logo-slider-sequence"
              aria-hidden={setIndex === 1}
              data-logo-slider-sequence
            >
              {logos.map((logo, i) => {
                const logoLabel = logo.alt ?? t.altPattern(logo.name);
                const isEager = setIndex === 0 && i < 4;
                const img = (
                  <img
                    src={logo.src}
                    srcSet={logo.srcSet}
                    sizes="(max-width: 768px) 144px, 216px"
                    alt={logoLabel}
                    title={logoLabel}
                    width={280}
                    height={112}
                    loading={isEager ? "eager" : "lazy"}
                    decoding="async"
                    fetchPriority={isEager ? "high" : "low"}
                    className="logo-slider-img"
                  />
                );
                return (
                <div key={`${logo.name}-${setIndex}`} className="logo-slider-item" data-logo-slider-item>
                  {logo.href ? (
                    <a
                      href={logo.href}
                      target="_blank"
                      rel="noopener external"
                      aria-label={logoLabel}
                      tabIndex={setIndex === 1 ? -1 : 0}
                    >
                      {img}
                    </a>
                  ) : (
                    img
                  )}
                </div>
                );
              })}
            </div>
          ))}
        </div>
      </div>

      <button
        type="button"
        onClick={() => setPaused((current) => !current)}
        className="logo-slider-toggle"
        aria-label={paused ? t.resumeLabel : t.pauseLabel}
        aria-pressed={paused}
      >
        {paused ? t.resumeLabel : t.pauseLabel}
      </button>
    </div>
  );
}
